/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Please Contribute"
    }), "\n", _jsxs(_components.p, {
      children: ["Eufemia is a ", _jsx(_components.a, {
        href: "/design-system/about/living-system",
        children: "living design system"
      }), ". It doesn't have a 'finished' state. Continuous improvement, removal and addition of content is important if it is to remain relevant as a resource for current and future DNB products and services."]
    }), "\n", _jsxs(_components.p, {
      children: ["Your input, comments and discussions are all valuable. ", _jsx(_components.a, {
        href: "/design-system/contact",
        children: "Reach out to us"
      }), ". And please ", _jsx(_components.a, {
        href: "/contribute",
        children: "contribute"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
